export const compatibilityService = {
    checkCompatibility
};

async function checkCompatibility(
    vin,
    partNumber
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/check-compatibility?` + new URLSearchParams({
        vin: vin,
        part_number: partNumber
    }), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}